export default __webpack_public_path__ + "static/article-unexpected-wedding-costs-aedf8502119e8906728bf2b029e5844b.jpg";